module.exports = __webpack_public_path__ + "static/media/14.pic.60c29ed1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/14.pic.jpg
// module id = 341
// module chunks = 0